// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"d14effc7","496":"745606a3","498":"01108afe","703":"2af268d5"}[chunkId] + ".chunk.js";
};